<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Testes</h1>
          </div>
          <h3 style="color:#888888" class="subtitle">{{ getClientName() }}</h3>
        </div>
        <!-- <div class="level-right">
          <div class="level-item">
            <b-button icon-right="plus" type="is-success">Adicionar</b-button>
          </div>
        </div> -->
      </div>
    </div>

    <h1>OFFLINE APS</h1>
    <div class="card has-table">
      <b-loading
        :is-full-page="false"
        :active.sync="isLoadingRadio"
      ></b-loading>
      <div class="card-header"></div>

      <!--tabelaaaaaaa-->
      <b-table
        striped
        hover
        :data="offline_aps_data"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
      >
        <template slot-scope="props">
          <b-table-column sortable field="group" label="Grupo">{{
            props.row.group
          }}</b-table-column>
          <b-table-column sortable field="name" label="Nome">{{
            props.row.name
          }}</b-table-column>
          <b-table-column sortable field="total_aps" label="Total de APs">{{
            props.row.total_aps
          }}</b-table-column>
          <b-table-column sortable field="offline_aps" label="APs offline">{{
            props.row.offline_aps
          }}</b-table-column>
          <b-table-column
            sortable
            field="percent_off"
            label="Porcentagem offline"
            >{{
              Math.round((props.row.offline_aps * 100) / props.row.total_aps)
            }}</b-table-column
          >
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem dados para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>

    <h1>DASHBOARD</h1>
    <div class="card has-table">
      <b-loading
        :is-full-page="false"
        :active.sync="isLoadingDashboard"
      ></b-loading>
      <div class="card-header"></div>
      <b-table
        striped
        hover
        :data="dashboard_data"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
      >
        <template slot-scope="props">
          <b-table-column sortable field="group" label="Grupo">{{
            props.row.group
          }}</b-table-column>
          <b-table-column sortable field="name" label="Nome">{{
            props.row.name
          }}</b-table-column>
          <b-table-column sortable field="error" label="Erro">{{
            props.row.error
          }}</b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem dados para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>

    <h1>OFFLINE TIME</h1>
    <div class="card has-table">
      <b-loading
        :is-full-page="false"
        :active.sync="isLoadingOffline"
      ></b-loading>
      <div class="card-header"></div>

      <!--tabelaaaaaaa-->
      <b-table
        striped
        hover
        :data="offline_aps_time_data"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
      >
        <template slot-scope="props">
          <b-table-column sortable field="radio_prefix" label="Radio Prefix">{{
            props.row.clientname
          }}</b-table-column>
          <b-table-column sortable field="ap" label="AP">{{
            props.row.name
          }}</b-table-column>
          <b-table-column
            sortable
            field="hours"
            label="Tempo offline (em horas)"
            >{{ props.row.hours }}</b-table-column
          >
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem dados para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>

    <h1>MAPS</h1>
    <div class="card has-table">
      <b-loading :is-full-page="false" :active.sync="isLoadingMap"></b-loading>
      <div class="card-header"></div>

      <!--tabelaaaaaaa-->
      <b-table
        striped
        hover
        :data="maps_data"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
      >
        <template slot-scope="props">
          <b-table-column sortable field="group" label="Grupo">{{
            props.row.group
          }}</b-table-column>
          <b-table-column sortable field="name" label="Nome">{{
            props.row.name
          }}</b-table-column>
          <b-table-column sortable field="sensoriado" label="Sensoriado">{{
            props.row.sensor
          }}</b-table-column>
          <b-table-column sortable field="conectado" label="Conectado">{{
            props.row.connect
          }}</b-table-column>
        </template>
        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem dados para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "@/store";
import {
  testMapsPage,
  testDashboardGraph,
  testOfflineAPsTime,
  testOfflineAPsInClients
} from "../functions/check.js";

export default {
  data: () => ({
    perPage: 10,
    fields: [],
    virtual_page: 1,
    isLoadingMap: true,
    isLoadingRadio: true,
    isLoadingDashboard: true,
    isLoadingOffline: true,
    pagination: {
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    offline_aps_data: [],
    dashboard_data: [],
    maps_data: [],
    offline_aps_time_data: []
  }),
  computed: {
    ...mapGetters(["getID", "getClientID", "getToken"])
  },
  async mounted() {
    this.offline_aps_data = await testOfflineAPsInClients(this.getToken);
    this.isLoadingRadio = false;
    this.dashboard_data = await testDashboardGraph();
    this.isLoadingDashboard = false;
    this.maps_data = await testMapsPage();
    this.isLoadingMap = false;
    this.offline_aps_time_data = await testOfflineAPsTime(this.getToken);
    this.isLoadingOffline = false;
  },

  watch: {},

  async created() {},

  methods: {
    async testing() {
      //const l = await testDashboardGraph();
      const l = await testOfflineAPsTime();

      return l;
    },
    getClientName() {
      return store.state.client.name;
    }
  }
};
</script>

<style scoped>
.capitalize {
  text-transform: capitalize !important;
}
.Rectangle-1 {
  width: 221px !important;
  height: 48px !important;
  border-radius: 4px;
  background-color: #ff9801;
  color: white;
}

.date {
  font-weight: bold;
  color: #1a73e8;
}

.date:hover {
  color: #4cb0f3;
  cursor: pointer;
}

.mini-button {
  background-color: #ff9801;
  color: white;
  padding: 4px 6px;
  border-radius: 3px;
  margin: 0 4px;
  outline: 0;
}

.mini-button.denied {
  background-color: lightgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Teste.vue